export const drawer_catalog = {
  workflow_onboarding: {
    section: 'WORKFLOW - SUPPLIER ONBOARDING',
    title: 'ABC Tech Solutions',
    subtitle: 'Procurement Officer · Risk Medium · Due 15 May 2026',
    status: 'In progress',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    details_layout: 'list',
    details: [
      { label: 'Supplier', value: 'ABC Tech Solutions' },
      { label: 'Owner', value: 'P. Naidoo - Procurement Officer' },
      { label: 'Risk rating', value: 'Medium' },
      { label: 'Engagement', value: 'R 250 000 / year' },
      { label: 'Submitted', value: '12 May 2026' },
      { label: 'Due', value: '15 May 2026 - 2 days late', value_class: 'text-danger' }
    ],
    sections: [
      {
        title: 'Workflow path',
        badge: 'In progress',
        badge_class: 'bg-warning-subtle text-warning-emphasis',
        kind: 'timeline',
        items: [
          { title: 'Submitted', subtitle: 'Initial documents captured', meta: 'P. Naidoo - 12 May', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
          { title: 'Procurement review', subtitle: 'Threshold and need checked', meta: 'S. Khumalo - 13 May', icon: 'bi-check-lg', icon_class: 'is-green', connected: true },
          { title: 'Finance review', subtitle: 'Tax document expired - awaiting valid certificate', meta: 'Stalled 2 days', icon: 'bi-clock-history', icon_class: 'is-slate', connected: true },
          { title: 'Compliance review', subtitle: 'Blocked until missing evidence is uploaded', meta: '', icon: 'bi-lock', icon_class: 'is-slate', connected: true },
          { title: 'Executive approval', subtitle: 'CCO sign-off required', meta: '', icon: 'bi-lock', icon_class: 'is-slate', connected: false }
        ]
      },
      {
        title: 'Evidence checklist',
        badge: '2 missing',
        badge_class: 'bg-danger-subtle text-danger-emphasis',
        kind: 'items',
        items: [
          { title: 'Company registration (CIPC)', subtitle: 'Verified - 12 May 2026', badge: 'Valid', badge_class: 'bg-success-subtle text-success-emphasis', icon: 'bi-check-circle', icon_class: 'is-green' },
          { title: 'Tax compliance status', subtitle: 'Expired 03 May 2026 - requested 13 May', badge: 'Expired', badge_class: 'bg-danger-subtle text-danger-emphasis', icon: 'bi-x-circle', icon_class: 'is-red' },
          { title: 'BBBEE certificate', subtitle: 'Not uploaded', badge: 'Missing', badge_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-exclamation-circle', icon_class: 'is-orange' },
          { title: 'Conflict of interest declaration', subtitle: 'Cleared by Ethics - no related parties', badge: 'Cleared', badge_class: 'bg-success-subtle text-success-emphasis', icon: 'bi-check-circle', icon_class: 'is-green' }
        ]
      },
      {
        title: 'Activity',
        badge: '',
        badge_class: '',
        kind: 'timeline',
        items: [
          { title: 'S. Khumalo approved procurement review', subtitle: '', meta: '13 May - 14:22', icon: 'bi-person-check', icon_class: 'is-green', connected: true },
          { title: 'Tax document attached', subtitle: '', meta: '12 May - 09:10 - later rejected (expired)', icon: 'bi-paperclip', icon_class: 'is-green', connected: true },
          { title: 'AI flagged BBBEE missing', subtitle: '', meta: '12 May - 09:11', icon: 'bi-stars', icon_class: 'is-green', connected: false }
        ]
      }
    ],
    footer_actions: [
      { label: 'Ask AI', variant: 'ghost', icon: 'bi-stars' },
      { label: 'Reject', variant: 'outline-danger', icon: 'bi-x-circle' },
      { label: 'Request evidence', variant: 'outline-warning', icon: 'bi-send' },
      { label: 'Advance stage', variant: 'primary', icon: 'bi-arrow-right' }
    ]
  },
  payment_release: {
    section: 'WORKFLOW - PAYMENT RELEASE',
    title: 'Invoice INV-2219 - ABC Tech',
    subtitle: 'R 88 000 - Finance - 3-way match failed',
    status: 'Payment hold',
    status_class: 'bg-danger-subtle text-danger-emphasis',
    details: [
      { label: 'Invoice', value: 'INV-2219' },
      { label: 'Supplier', value: 'ABC Tech Solutions' },
      { label: 'Amount', value: 'R 88 000.00' },
      { label: 'PO', value: 'PO-3041 - partial match' },
      { label: 'Owner', value: 'Finance - J. Moyo' },
      { label: 'Status', value: 'Payment hold', value_class: 'text-danger' }
    ],
    sections: [
      {
        title: '3-WAY match',
        badge: 'Failed',
        badge_class: 'bg-danger-subtle text-danger-emphasis',
        kind: 'items',
        items: [
          { title: 'Purchase order', subtitle: 'PO-3041 approved', meta: 'Incomplete', icon: 'bi-file-earmark-text', icon_class: 'is-orange' },
          { title: 'Invoice', subtitle: 'Valid - within tolerance', meta: 'Valid', icon: 'bi-receipt', icon_class: 'is-green' },
          { title: 'Goods received note', subtitle: 'Signed GR', meta: 'Missing', icon: 'bi-box-seam', icon_class: 'is-red' },
          { title: 'Tax status', subtitle: 'Active certificate', meta: 'Expired', icon: 'bi-shield-exclamation', icon_class: 'is-red' }
        ]
      },
      {
        title: 'Linked controls',
        badge: '1 failed',
        badge_class: 'bg-danger-subtle text-danger-emphasis',
        kind: 'items',
        items: [
          { title: 'C-101 - Valid supplier tax status before payment', subtitle: 'Failed - last tested today', meta: 'Control', icon: 'bi-shield-exclamation', icon_class: 'is-red' }
        ]
      }
    ],
    footer_actions: [
      { label: 'Ask AI', variant: 'ghost', icon: 'bi-stars' },
      { label: 'Reject release', variant: 'outline-danger', icon: 'bi-x-circle' },
      { label: 'Request GR note', variant: 'outline-warning', icon: 'bi-paperclip' },
      { label: 'Release payment', variant: 'secondary', icon: 'bi-arrow-right' }
    ]
  },
  contract_breach: {
    section: 'CONTRACT · DOA BREACH',
    title: 'Platform support agreement',
    subtitle: 'NewGX Capital · R 520 000 · CFO + CEO required',
    status: 'Pending',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    details_layout: 'list',
    details: [
      { label: 'Contract', value: 'Platform support agreement' },
      { label: 'Counterparty', value: 'NewGX Capital' },
      { label: 'Value', value: 'R 520 000 · annual' },
      { label: 'Term', value: '24 months' },
      { label: 'Owner', value: 'Legal · A. de Wet' },
      { label: 'Status', value: 'CFO + CEO approval', value_class: 'text-warning-emphasis' }
    ],
    sections: [
      {
        title: 'DOA EVALUATION',
        badge: 'Triggered',
        badge_class: 'bg-warning-subtle text-warning-emphasis',
        kind: 'items',
        items: [
          { title: 'Contract value exceeds R 500 000 threshold', subtitle: 'Rule DoA-014 · Board policy v1', meta: 'Triggered', icon: 'bi-file-earmark-arrow-up', icon_class: 'is-orange' },
          { title: 'Change-control clause', subtitle: 'Legal must confirm presence before signature', meta: 'Pending', icon: 'bi-clipboard-check', icon_class: 'is-orange' },
          { title: 'Counterparty due diligence', subtitle: 'Approved supplier · low risk', meta: 'Cleared', icon: 'bi-check-circle', icon_class: 'is-green' }
        ]
      },
      {
        title: 'APPROVAL CHAIN',
        badge: 'Waiting',
        badge_class: 'bg-warning-subtle text-warning-emphasis',
        kind: 'timeline',
        items: [
          { title: 'Legal review', subtitle: 'Draft cleared by Legal', meta: '11 May · 17:40', icon: 'bi-check-circle-fill', icon_class: 'is-green', connected: true },
          { title: 'CFO approval', subtitle: 'Awaiting sign-off · DoA threshold breached', meta: '', icon: 'bi-record-circle', icon_class: 'is-slate', connected: true },
          { title: 'CEO approval', subtitle: 'Required because value > R 500 000', meta: '', icon: 'bi-person', icon_class: 'is-slate', connected: true },
          { title: 'Signature & filing', subtitle: 'Evidence stored in vault', meta: '', icon: 'bi-paperclip', icon_class: 'is-slate', connected: false }
        ]
      }
    ],
    footer_actions: [
      { label: 'Ask AI', variant: 'ghost', icon: 'bi-stars', position: 'left' },
      { label: 'Remind CFO', variant: 'outline-secondary', icon: 'bi-bell', position: 'right' },
      { label: 'Route to CFO', variant: 'primary', icon: 'bi-send', position: 'right' }
    ]
  },
  training_campaign: {
    section: 'TRAINING CAMPAIGN',
    title: 'POPIA refresher',
    subtitle: '76.1% complete - due 17 May 2026',
    status: 'Reminder sent',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    details: [
      { label: 'Course', value: 'POPIA refresher - 18 minutes' },
      { label: 'Audience', value: 'All staff (218)' },
      { label: 'Due', value: '17 May 2026' },
      { label: 'Completed', value: '166 / 218 - 76.1%' },
      { label: 'Last reminder', value: '13 May 09:00' }
    ],
    sections: [
      {
        title: 'Completion by department',
        badge: 'Track',
        badge_class: 'bg-light text-secondary border',
        kind: 'progress',
        items: [
          { label: 'Finance', percent: 100, count: '24/24', dot: '#c08a2a' },
          { label: 'Procurement', percent: 82, count: '18/22', dot: '#bf4f72' },
          { label: 'Sales', percent: 68, count: '38/56', dot: '#8a97a8' },
          { label: 'Operations', percent: 84, count: '42/50', dot: '#8a97a8' },
          { label: 'Legal', percent: 92, count: '11/12', dot: '#1f9a8a' },
          { label: 'IT Security', percent: 93, count: '14/15', dot: '#416176' },
          { label: 'HR', percent: 100, count: '19/19', dot: '#6d3ec7' }
        ]
      }
    ],
    footer_actions: [
      { label: 'Ask AI', variant: 'ghost', icon: 'bi-stars' },
      { label: 'Remind incomplete', variant: 'outline-secondary', icon: 'bi-bell' },
      { label: 'Escalate to managers', variant: 'primary', icon: 'bi-arrow-right' }
    ]
  },
  detail_view: {
    section: 'DETAIL',
    title: 'Record',
    subtitle: '',
    body_title: 'Detail view',
    body_copy: 'Drill-in for procurement would show timeline, evidence, controls, and a recommended action.'
  },
  access_review: {
    section: 'CONTROL - ACCESS REVIEW',
    title: 'Admin access review',
    subtitle: 'C-322 - monthly - overdue 14 days',
    status: 'Overdue',
    status_class: 'bg-danger-subtle text-danger-emphasis',
    details: [
      { label: 'Control', value: 'C-322 - Admin access reviewed monthly' },
      { label: 'Owner', value: 'CISO - M. Khoza' },
      { label: 'Frequency', value: 'Monthly' },
      { label: 'Last review', value: '14 Apr 2026 - overdue', value_class: 'text-danger' },
      { label: 'Privileged accounts', value: '8 requiring validation' }
    ],
    sections: [
      {
        title: 'Privileged accounts',
        badge: 'Review',
        badge_class: 'bg-danger-subtle text-danger-emphasis',
        kind: 'items',
        items: [
          { title: 'svc-azure-deploy', subtitle: 'Azure tenant', meta: '10 May', badge: 'Review', badge_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-server', icon_class: 'is-red' },
          { title: 'root-prod-db', subtitle: 'Production DB', meta: '12 May', badge: 'Validate', badge_class: 'bg-danger-subtle text-danger-emphasis', icon: 'bi-database', icon_class: 'is-red' },
          { title: 'admin-okta', subtitle: 'Okta IdP', meta: '13 May', badge: 'Review', badge_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-person-gear', icon_class: 'is-orange' },
          { title: 'backup-svc', subtitle: 'Backup', meta: '01 May', badge: 'Inactive', badge_class: 'bg-danger-subtle text-danger-emphasis', icon: 'bi-cloud-arrow-up', icon_class: 'is-red' }
        ]
      }
    ],
    footer_actions: [
      { label: 'Ask AI', variant: 'ghost', icon: 'bi-stars' },
      { label: 'Request report', variant: 'outline-secondary', icon: 'bi-upload' },
      { label: 'Schedule review', variant: 'primary', icon: 'bi-calendar2-plus' }
    ]
  }
};
